import {endOfMonth, endOfWeek, format, isSameDay, startOfMonth, startOfWeek, startOfYear, endOfYear, subDays} from "date-fns";
import {DATE_SHORTCUTS} from "@/utils/const";
import {isMeaningful, isMeaningless} from "@/utils/common";

/**
 * @description 时间戳转换成yyyy-mm-dd格式
 */
export const convertToFullDate = (date, formatStr) => {
  if (!date || date.toString() === 'Invalid Date') {
    return null;
  }

  if (typeof date === 'string') {
    date = new Date(date)
  }

  return format(date, formatStr);
};

/**
 * @description 时间戳转换成yyyy-mm-dd格式
 */
export const convertToDate = (date) => {
  if (!date) {
    return null;
  }
  if (typeof date === 'string') {

    date = new Date(date)
  }
  return format(date, 'yyyy-MM-dd');
};

export const convertToMonth = (date) => {
  if (!date) {
    return null;
  }
  return format(date, 'yyyy-MM');
};

/**
 * 时区转换
 * 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
 */

export function getLocalTime(i) {

  if (typeof i !== 'number') return;

  const d = new Date();

  //得到1970年一月一日到现在的秒数
  const len = d.getTime();

  //本地时间与GMT时间的时间偏移差
  const offset = d.getTimezoneOffset() * 60000;

  //得到现在的格林尼治时间
  const utcTime = len + offset;

  return new Date(utcTime + 3600000 * i);

}

export function dateShortcut(date) {
  if (isMeaningless(date) || date.length < 2) {
    return '';
  }
  for (let key in DATE_SHORTCUTS) {
    const shortcutDate = DATE_SHORTCUTS[key].date;
    if (isSameDay(date[0], shortcutDate[0]) && isSameDay(date[1], shortcutDate[1])) {
      return DATE_SHORTCUTS[key].text;
    }
  }
}

/**
 * 构造视图参数
 */
export const generateViewParams = (params, key = 'dateRange') => {
  if (!isMeaningful(params[key])) return Promise.resolve(params)
  let [ startDateTime = '', endDateTime = '' ] = generatorTrulyDateTime(params[key]);
  params.startDateTime = convertToDate(startDateTime);
  params.endDateTime = convertToDate(endDateTime);
  return Promise.resolve(params);
}
/**
 * 处理选中时间
 * @param dateRange 时间范围
 */
const generatorTrulyDateTime = (dateRange = 'today') => {
  return generatorDate(dateRange)
}

/**
 * 处理选中日期范围
 * @param dateRange 选中值
 * @returns {{startDateTime: string, endDateTime: string}|Date[]}
 */
export const generatorDate = (dateRange) => {
  if (!isMeaningful(dateRange)) return ['', '']
  let end = new Date()
  let start = new Date()
  switch (dateRange) {
    case 1:
      start = subDays(start, 1)
      end = subDays(end, 1)
      break;
    case 2:
      start = subDays(start, 6)
      break
    case 3:
      start = subDays(start, 13)
      break
    case 4:
      start = subDays(start, 29)
      break
    case 5:
      start = subDays(start, 59)
      break
    case 6:
      start = startOfWeek(start)
      end = endOfWeek(end)
      break
    case 7:
      start = startOfMonth(start)
      end = endOfMonth(end)
      break
    case 8:
      start = startOfYear(start)
      break
  }
  return [start, end]
}

